import type { Community } from '~/interfaces/community/community';
import type { CommunityLockReason } from '~/interfaces/community/space';

export const communityIsAccessible = (community: Community | null | undefined): boolean =>
  community == null || !community.gated || community.community_accessible;

// Matches AccessGated#lock_reason_for: anything but a missing tier is a condition lock.
export const isConditionLock = (reason: CommunityLockReason | null | undefined): boolean =>
  reason != null && reason !== 'tier';
